unit SubsLoadsProcessing;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, WEBLib.StdCtrls, WEBLib.DBCtrls, Vcl.StdCtrls,
  Vcl.Controls, WEBLib.ExtCtrls, WEBLib.WebCtrls;

type
  TForm4 = class(TForm)
    WebPanel1: TPanel;
    WebPanel2: TPanel;
    WebPanel4: TPanel;
    WebDBEdit1: TDBEdit;
    WebDBEdit2: TDBEdit;
    WebDBEdit3: TDBEdit;
    WebDBEdit4: TDBEdit;
    WebDBEdit5: TDBEdit;
    WebDBEdit6: TDBEdit;
    WebDBEdit7: TDBEdit;
    WebDBEdit8: TDBEdit;
    WebDBEdit9: TDBEdit;
    WebDBEdit10: TDBEdit;
    WebDBEdit11: TDBEdit;
    WebDBCheckBox1: TDBCheckBox;
    WebDBCheckBox2: TDBCheckBox;
    WebDBCheckBox3: TDBCheckBox;
    WebDBCheckBox4: TDBCheckBox;
    WebDBDateTimePicker1: TDBDateTimePicker;
    WebDBDateTimePicker2: TDBDateTimePicker;
    WebDateTimePicker1: TDateTimePicker;
    WebDateTimePicker2: TDateTimePicker;
    WebDateTimePicker3: TDateTimePicker;
    WebDateTimePicker4: TDateTimePicker;
    WebDateTimePicker5: TDateTimePicker;
    WebDateTimePicker6: TDateTimePicker;
    WebDateTimePicker7: TDateTimePicker;
    WebDateTimePicker8: TDateTimePicker;
    WebDBCheckBox5: TDBCheckBox;
    WebDBEdit12: TDBEdit;
    WebDateTimePicker9: TDateTimePicker;
    WebEdit1: TEdit;
    WebDBCheckBox6: TDBCheckBox;
    WebDBEdit13: TDBEdit;
    WebDBEdit14: TDBEdit;
    WebDBEdit15: TDBEdit;
    WebDBEdit16: TDBEdit;
    WebDBEdit17: TDBEdit;
    WebLabel1: TLabel;
    WebLabel2: TLabel;
    WebLabel3: TLabel;
    WebLabel4: TLabel;
    WebLabel5: TLabel;
    WebLabel6: TLabel;
    WebLabel7: TLabel;
    WebLabel8: TLabel;
    WebLabel9: TLabel;
    WebLabel10: TLabel;
    WebLabel11: TLabel;
    WebLabel12: TLabel;
    WebLabel13: TLabel;
    WebLabel14: TLabel;
    WebLabel15: TLabel;
    WebLabel16: TLabel;
    WebLabel17: TLabel;
    WebLabel18: TLabel;
    WebLabel19: TLabel;
    WebLabel20: TLabel;
    WebLabel21: TLabel;
    WebLabel22: TLabel;
    WebLabel23: TLabel;
    WebLabel24: TLabel;
    WebLabel25: TLabel;
    WebPanel3: TPanel;
    WebButton1: TButton;
    WebButton2: TButton;
    Invoice: TFilePicker;
    Documentation: TFilePicker;
    procedure WebButton2Click(Sender: TObject);
  private
    { Private declarations }
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  Form4: TForm4;

implementation

{$R *.dfm}

procedure TForm4.WebButton2Click(Sender: TObject);
begin

  Close;
end;

procedure TForm4.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  WebPanel4 := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  WebLabel6 := TLabel.Create(Self);
  WebLabel7 := TLabel.Create(Self);
  WebLabel8 := TLabel.Create(Self);
  WebLabel9 := TLabel.Create(Self);
  WebLabel10 := TLabel.Create(Self);
  WebLabel11 := TLabel.Create(Self);
  WebLabel12 := TLabel.Create(Self);
  WebLabel13 := TLabel.Create(Self);
  WebLabel14 := TLabel.Create(Self);
  WebLabel15 := TLabel.Create(Self);
  WebLabel16 := TLabel.Create(Self);
  WebLabel17 := TLabel.Create(Self);
  WebLabel18 := TLabel.Create(Self);
  WebLabel19 := TLabel.Create(Self);
  WebLabel20 := TLabel.Create(Self);
  WebLabel21 := TLabel.Create(Self);
  WebLabel22 := TLabel.Create(Self);
  WebLabel23 := TLabel.Create(Self);
  WebLabel24 := TLabel.Create(Self);
  WebLabel25 := TLabel.Create(Self);
  WebDBEdit1 := TDBEdit.Create(Self);
  WebDBEdit2 := TDBEdit.Create(Self);
  WebDBEdit3 := TDBEdit.Create(Self);
  WebDBEdit4 := TDBEdit.Create(Self);
  WebDBEdit5 := TDBEdit.Create(Self);
  WebDBEdit6 := TDBEdit.Create(Self);
  WebDBEdit7 := TDBEdit.Create(Self);
  WebDBEdit8 := TDBEdit.Create(Self);
  WebDBEdit9 := TDBEdit.Create(Self);
  WebDBEdit10 := TDBEdit.Create(Self);
  WebDBEdit11 := TDBEdit.Create(Self);
  WebDBCheckBox1 := TDBCheckBox.Create(Self);
  WebDBCheckBox2 := TDBCheckBox.Create(Self);
  WebDBCheckBox3 := TDBCheckBox.Create(Self);
  WebDBCheckBox4 := TDBCheckBox.Create(Self);
  WebDBDateTimePicker1 := TDBDateTimePicker.Create(Self);
  WebDBDateTimePicker2 := TDBDateTimePicker.Create(Self);
  WebDateTimePicker1 := TDateTimePicker.Create(Self);
  WebDateTimePicker2 := TDateTimePicker.Create(Self);
  WebDateTimePicker3 := TDateTimePicker.Create(Self);
  WebDateTimePicker4 := TDateTimePicker.Create(Self);
  WebDateTimePicker5 := TDateTimePicker.Create(Self);
  WebDateTimePicker6 := TDateTimePicker.Create(Self);
  WebDateTimePicker7 := TDateTimePicker.Create(Self);
  WebDateTimePicker8 := TDateTimePicker.Create(Self);
  WebDBCheckBox5 := TDBCheckBox.Create(Self);
  WebDBEdit12 := TDBEdit.Create(Self);
  WebDateTimePicker9 := TDateTimePicker.Create(Self);
  WebEdit1 := TEdit.Create(Self);
  WebDBCheckBox6 := TDBCheckBox.Create(Self);
  WebDBEdit13 := TDBEdit.Create(Self);
  WebDBEdit14 := TDBEdit.Create(Self);
  WebDBEdit15 := TDBEdit.Create(Self);
  WebDBEdit16 := TDBEdit.Create(Self);
  WebDBEdit17 := TDBEdit.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  WebButton1 := TButton.Create(Self);
  WebButton2 := TButton.Create(Self);
  Invoice := TFilePicker.Create(Self);
  Documentation := TFilePicker.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  WebPanel4.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  WebLabel7.BeforeLoadDFMValues;
  WebLabel8.BeforeLoadDFMValues;
  WebLabel9.BeforeLoadDFMValues;
  WebLabel10.BeforeLoadDFMValues;
  WebLabel11.BeforeLoadDFMValues;
  WebLabel12.BeforeLoadDFMValues;
  WebLabel13.BeforeLoadDFMValues;
  WebLabel14.BeforeLoadDFMValues;
  WebLabel15.BeforeLoadDFMValues;
  WebLabel16.BeforeLoadDFMValues;
  WebLabel17.BeforeLoadDFMValues;
  WebLabel18.BeforeLoadDFMValues;
  WebLabel19.BeforeLoadDFMValues;
  WebLabel20.BeforeLoadDFMValues;
  WebLabel21.BeforeLoadDFMValues;
  WebLabel22.BeforeLoadDFMValues;
  WebLabel23.BeforeLoadDFMValues;
  WebLabel24.BeforeLoadDFMValues;
  WebLabel25.BeforeLoadDFMValues;
  WebDBEdit1.BeforeLoadDFMValues;
  WebDBEdit2.BeforeLoadDFMValues;
  WebDBEdit3.BeforeLoadDFMValues;
  WebDBEdit4.BeforeLoadDFMValues;
  WebDBEdit5.BeforeLoadDFMValues;
  WebDBEdit6.BeforeLoadDFMValues;
  WebDBEdit7.BeforeLoadDFMValues;
  WebDBEdit8.BeforeLoadDFMValues;
  WebDBEdit9.BeforeLoadDFMValues;
  WebDBEdit10.BeforeLoadDFMValues;
  WebDBEdit11.BeforeLoadDFMValues;
  WebDBCheckBox1.BeforeLoadDFMValues;
  WebDBCheckBox2.BeforeLoadDFMValues;
  WebDBCheckBox3.BeforeLoadDFMValues;
  WebDBCheckBox4.BeforeLoadDFMValues;
  WebDBDateTimePicker1.BeforeLoadDFMValues;
  WebDBDateTimePicker2.BeforeLoadDFMValues;
  WebDateTimePicker1.BeforeLoadDFMValues;
  WebDateTimePicker2.BeforeLoadDFMValues;
  WebDateTimePicker3.BeforeLoadDFMValues;
  WebDateTimePicker4.BeforeLoadDFMValues;
  WebDateTimePicker5.BeforeLoadDFMValues;
  WebDateTimePicker6.BeforeLoadDFMValues;
  WebDateTimePicker7.BeforeLoadDFMValues;
  WebDateTimePicker8.BeforeLoadDFMValues;
  WebDBCheckBox5.BeforeLoadDFMValues;
  WebDBEdit12.BeforeLoadDFMValues;
  WebDateTimePicker9.BeforeLoadDFMValues;
  WebEdit1.BeforeLoadDFMValues;
  WebDBCheckBox6.BeforeLoadDFMValues;
  WebDBEdit13.BeforeLoadDFMValues;
  WebDBEdit14.BeforeLoadDFMValues;
  WebDBEdit15.BeforeLoadDFMValues;
  WebDBEdit16.BeforeLoadDFMValues;
  WebDBEdit17.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  WebButton1.BeforeLoadDFMValues;
  WebButton2.BeforeLoadDFMValues;
  Invoice.BeforeLoadDFMValues;
  Documentation.BeforeLoadDFMValues;
  try
    Name := 'Form4';
    Width := 633;
    Height := 745;
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 633;
    WebPanel1.Height := 745;
    WebPanel1.Align := alClient;
    WebPanel1.TabOrder := 0;
    WebPanel2.SetParentComponent(WebPanel1);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 0;
    WebPanel2.Top := 0;
    WebPanel2.Width := 633;
    WebPanel2.Height := 60;
    WebPanel2.Align := alTop;
    WebPanel2.Caption := 'Subs Loads Processing';
    WebPanel2.Color := clSilver;
    WebPanel2.Font.Charset := DEFAULT_CHARSET;
    WebPanel2.Font.Color := clWindowText;
    WebPanel2.Font.Height := -16;
    WebPanel2.Font.Name := 'Segoe UI';
    WebPanel2.Font.Style := [fsBold];
    WebPanel2.ParentFont := False;
    WebPanel2.TabOrder := 0;
    WebPanel4.SetParentComponent(WebPanel1);
    WebPanel4.Name := 'WebPanel4';
    WebPanel4.Left := 0;
    WebPanel4.Top := 60;
    WebPanel4.Width := 633;
    WebPanel4.Height := 685;
    WebPanel4.Align := alClient;
    WebPanel4.ChildOrder := 2;
    WebPanel4.TabOrder := 1;
    WebLabel1.SetParentComponent(WebPanel4);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 31;
    WebLabel1.Top := 24;
    WebLabel1.Width := 91;
    WebLabel1.Height := 15;
    WebLabel1.Caption := 'Loading Way Bill:';
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebLabel2.SetParentComponent(WebPanel4);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 207;
    WebLabel2.Top := 24;
    WebLabel2.Width := 113;
    WebLabel2.Height := 15;
    WebLabel2.Caption := 'Off-Loading Way Bill:';
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebLabel3.SetParentComponent(WebPanel4);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 383;
    WebLabel3.Top := 25;
    WebLabel3.Width := 59;
    WebLabel3.Height := 15;
    WebLabel3.Caption := 'Docket No:';
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.WidthPercent := 100.000000000000000000;
    WebLabel4.SetParentComponent(WebPanel4);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 31;
    WebLabel4.Top := 72;
    WebLabel4.Width := 108;
    WebLabel4.Height := 15;
    WebLabel4.Caption := 'Loading Killometers:';
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.WidthPercent := 100.000000000000000000;
    WebLabel5.SetParentComponent(WebPanel4);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 207;
    WebLabel5.Top := 72;
    WebLabel5.Width := 121;
    WebLabel5.Height := 15;
    WebLabel5.Caption := 'Off-Loading Kilometrs:';
    WebLabel5.HeightPercent := 100.000000000000000000;
    WebLabel5.WidthPercent := 100.000000000000000000;
    WebLabel6.SetParentComponent(WebPanel4);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 32;
    WebLabel6.Top := 143;
    WebLabel6.Width := 86;
    WebLabel6.Height := 15;
    WebLabel6.Caption := 'Loading Tare Qy';
    WebLabel6.HeightPercent := 100.000000000000000000;
    WebLabel6.WidthPercent := 100.000000000000000000;
    WebLabel7.SetParentComponent(WebPanel4);
    WebLabel7.Name := 'WebLabel7';
    WebLabel7.Left := 32;
    WebLabel7.Top := 171;
    WebLabel7.Width := 97;
    WebLabel7.Height := 15;
    WebLabel7.Caption := 'Loading Gross Qty';
    WebLabel7.HeightPercent := 100.000000000000000000;
    WebLabel7.WidthPercent := 100.000000000000000000;
    WebLabel8.SetParentComponent(WebPanel4);
    WebLabel8.Name := 'WebLabel8';
    WebLabel8.Left := 32;
    WebLabel8.Top := 199;
    WebLabel8.Width := 95;
    WebLabel8.Height := 15;
    WebLabel8.Caption := 'Loading Mass Qty';
    WebLabel8.HeightPercent := 100.000000000000000000;
    WebLabel8.WidthPercent := 100.000000000000000000;
    WebLabel9.SetParentComponent(WebPanel4);
    WebLabel9.Name := 'WebLabel9';
    WebLabel9.Left := 312;
    WebLabel9.Top := 143;
    WebLabel9.Width := 112;
    WebLabel9.Height := 15;
    WebLabel9.Caption := 'Off-Loading Tare Qty';
    WebLabel9.HeightPercent := 100.000000000000000000;
    WebLabel9.WidthPercent := 100.000000000000000000;
    WebLabel10.SetParentComponent(WebPanel4);
    WebLabel10.Name := 'WebLabel10';
    WebLabel10.Left := 312;
    WebLabel10.Top := 171;
    WebLabel10.Width := 119;
    WebLabel10.Height := 15;
    WebLabel10.Caption := 'Off-Loading Gross Qty';
    WebLabel10.HeightPercent := 100.000000000000000000;
    WebLabel10.WidthPercent := 100.000000000000000000;
    WebLabel11.SetParentComponent(WebPanel4);
    WebLabel11.Name := 'WebLabel11';
    WebLabel11.Left := 312;
    WebLabel11.Top := 199;
    WebLabel11.Width := 122;
    WebLabel11.Height := 15;
    WebLabel11.Caption := 'Off-Loading masss Qty';
    WebLabel11.HeightPercent := 100.000000000000000000;
    WebLabel11.WidthPercent := 100.000000000000000000;
    WebLabel12.SetParentComponent(WebPanel4);
    WebLabel12.Name := 'WebLabel12';
    WebLabel12.Left := 31;
    WebLabel12.Top := 287;
    WebLabel12.Width := 69;
    WebLabel12.Height := 15;
    WebLabel12.Caption := 'Loaded Date:';
    WebLabel12.HeightPercent := 100.000000000000000000;
    WebLabel12.WidthPercent := 100.000000000000000000;
    WebLabel13.SetParentComponent(WebPanel4);
    WebLabel13.Name := 'WebLabel13';
    WebLabel13.Left := 330;
    WebLabel13.Top := 287;
    WebLabel13.Width := 90;
    WebLabel13.Height := 15;
    WebLabel13.Caption := 'Off-Loaded date:';
    WebLabel13.HeightPercent := 100.000000000000000000;
    WebLabel13.WidthPercent := 100.000000000000000000;
    WebLabel14.SetParentComponent(WebPanel4);
    WebLabel14.Name := 'WebLabel14';
    WebLabel14.Left := 31;
    WebLabel14.Top := 315;
    WebLabel14.Width := 67;
    WebLabel14.Height := 15;
    WebLabel14.Caption := 'Arrival Time:';
    WebLabel14.HeightPercent := 100.000000000000000000;
    WebLabel14.WidthPercent := 100.000000000000000000;
    WebLabel15.SetParentComponent(WebPanel4);
    WebLabel15.Name := 'WebLabel15';
    WebLabel15.Left := 32;
    WebLabel15.Top := 345;
    WebLabel15.Width := 55;
    WebLabel15.Height := 15;
    WebLabel15.Caption := 'Departure:';
    WebLabel15.HeightPercent := 100.000000000000000000;
    WebLabel15.WidthPercent := 100.000000000000000000;
    WebLabel16.SetParentComponent(WebPanel4);
    WebLabel16.Name := 'WebLabel16';
    WebLabel16.Left := 330;
    WebLabel16.Top := 315;
    WebLabel16.Width := 67;
    WebLabel16.Height := 15;
    WebLabel16.Caption := 'Arrival Time:';
    WebLabel16.HeightPercent := 100.000000000000000000;
    WebLabel16.WidthPercent := 100.000000000000000000;
    WebLabel17.SetParentComponent(WebPanel4);
    WebLabel17.Name := 'WebLabel17';
    WebLabel17.Left := 330;
    WebLabel17.Top := 345;
    WebLabel17.Width := 55;
    WebLabel17.Height := 15;
    WebLabel17.Caption := 'Departure:';
    WebLabel17.HeightPercent := 100.000000000000000000;
    WebLabel17.WidthPercent := 100.000000000000000000;
    WebLabel18.SetParentComponent(WebPanel4);
    WebLabel18.Name := 'WebLabel18';
    WebLabel18.Left := 305;
    WebLabel18.Top := 401;
    WebLabel18.Width := 88;
    WebLabel18.Height := 15;
    WebLabel18.Caption := 'Invoice Number:';
    WebLabel18.HeightPercent := 100.000000000000000000;
    WebLabel18.WidthPercent := 100.000000000000000000;
    WebLabel19.SetParentComponent(WebPanel4);
    WebLabel19.Name := 'WebLabel19';
    WebLabel19.Left := 306;
    WebLabel19.Top := 455;
    WebLabel19.Width := 68;
    WebLabel19.Height := 15;
    WebLabel19.Caption := 'Invoice Date:';
    WebLabel19.HeightPercent := 100.000000000000000000;
    WebLabel19.WidthPercent := 100.000000000000000000;
    WebLabel20.SetParentComponent(WebPanel4);
    WebLabel20.Name := 'WebLabel20';
    WebLabel20.Left := 306;
    WebLabel20.Top := 483;
    WebLabel20.Width := 78;
    WebLabel20.Height := 15;
    WebLabel20.Caption := 'Invoice Period:';
    WebLabel20.HeightPercent := 100.000000000000000000;
    WebLabel20.WidthPercent := 100.000000000000000000;
    WebLabel21.SetParentComponent(WebPanel4);
    WebLabel21.Name := 'WebLabel21';
    WebLabel21.Left := 32;
    WebLabel21.Top := 455;
    WebLabel21.Width := 49;
    WebLabel21.Height := 15;
    WebLabel21.Caption := 'Sub Rate:';
    WebLabel21.HeightPercent := 100.000000000000000000;
    WebLabel21.WidthPercent := 100.000000000000000000;
    WebLabel22.SetParentComponent(WebPanel4);
    WebLabel22.Name := 'WebLabel22';
    WebLabel22.Left := 32;
    WebLabel22.Top := 483;
    WebLabel22.Width := 51;
    WebLabel22.Height := 15;
    WebLabel22.Caption := 'Sub Tons:';
    WebLabel22.HeightPercent := 100.000000000000000000;
    WebLabel22.WidthPercent := 100.000000000000000000;
    WebLabel23.SetParentComponent(WebPanel4);
    WebLabel23.Name := 'WebLabel23';
    WebLabel23.Left := 32;
    WebLabel23.Top := 511;
    WebLabel23.Width := 54;
    WebLabel23.Height := 15;
    WebLabel23.Caption := 'Sub-Total:';
    WebLabel23.HeightPercent := 100.000000000000000000;
    WebLabel23.WidthPercent := 100.000000000000000000;
    WebLabel24.SetParentComponent(WebPanel4);
    WebLabel24.Name := 'WebLabel24';
    WebLabel24.Left := 31;
    WebLabel24.Top := 539;
    WebLabel24.Width := 19;
    WebLabel24.Height := 15;
    WebLabel24.Caption := 'Vat:';
    WebLabel24.HeightPercent := 100.000000000000000000;
    WebLabel24.WidthPercent := 100.000000000000000000;
    WebLabel25.SetParentComponent(WebPanel4);
    WebLabel25.Name := 'WebLabel25';
    WebLabel25.Left := 31;
    WebLabel25.Top := 567;
    WebLabel25.Width := 51;
    WebLabel25.Height := 15;
    WebLabel25.Caption := 'Total Incl:';
    WebLabel25.HeightPercent := 100.000000000000000000;
    WebLabel25.WidthPercent := 100.000000000000000000;
    WebDBEdit1.SetParentComponent(WebPanel4);
    WebDBEdit1.Name := 'WebDBEdit1';
    WebDBEdit1.Left := 31;
    WebDBEdit1.Top := 40;
    WebDBEdit1.Width := 150;
    WebDBEdit1.Height := 22;
    WebDBEdit1.HeightPercent := 100.000000000000000000;
    WebDBEdit1.Text := 'WebDBEdit1';
    WebDBEdit1.WidthPercent := 100.000000000000000000;
    WebDBEdit2.SetParentComponent(WebPanel4);
    WebDBEdit2.Name := 'WebDBEdit2';
    WebDBEdit2.Left := 207;
    WebDBEdit2.Top := 40;
    WebDBEdit2.Width := 150;
    WebDBEdit2.Height := 22;
    WebDBEdit2.ChildOrder := 1;
    WebDBEdit2.HeightPercent := 100.000000000000000000;
    WebDBEdit2.Text := 'WebDBEdit2';
    WebDBEdit2.WidthPercent := 100.000000000000000000;
    WebDBEdit3.SetParentComponent(WebPanel4);
    WebDBEdit3.Name := 'WebDBEdit3';
    WebDBEdit3.Left := 381;
    WebDBEdit3.Top := 40;
    WebDBEdit3.Width := 154;
    WebDBEdit3.Height := 22;
    WebDBEdit3.ChildOrder := 2;
    WebDBEdit3.HeightPercent := 100.000000000000000000;
    WebDBEdit3.Text := 'WebDBEdit3';
    WebDBEdit3.WidthPercent := 100.000000000000000000;
    WebDBEdit4.SetParentComponent(WebPanel4);
    WebDBEdit4.Name := 'WebDBEdit4';
    WebDBEdit4.Left := 31;
    WebDBEdit4.Top := 93;
    WebDBEdit4.Width := 150;
    WebDBEdit4.Height := 22;
    WebDBEdit4.ChildOrder := 3;
    WebDBEdit4.HeightPercent := 100.000000000000000000;
    WebDBEdit4.Text := 'WebDBEdit4';
    WebDBEdit4.WidthPercent := 100.000000000000000000;
    WebDBEdit5.SetParentComponent(WebPanel4);
    WebDBEdit5.Name := 'WebDBEdit5';
    WebDBEdit5.Left := 207;
    WebDBEdit5.Top := 88;
    WebDBEdit5.Width := 150;
    WebDBEdit5.Height := 22;
    WebDBEdit5.ChildOrder := 4;
    WebDBEdit5.HeightPercent := 100.000000000000000000;
    WebDBEdit5.Text := 'WebDBEdit5';
    WebDBEdit5.WidthPercent := 100.000000000000000000;
    WebDBEdit6.SetParentComponent(WebPanel4);
    WebDBEdit6.Name := 'WebDBEdit6';
    WebDBEdit6.Left := 135;
    WebDBEdit6.Top := 143;
    WebDBEdit6.Width := 121;
    WebDBEdit6.Height := 22;
    WebDBEdit6.ChildOrder := 5;
    WebDBEdit6.HeightPercent := 100.000000000000000000;
    WebDBEdit6.Text := 'WebDBEdit6';
    WebDBEdit6.WidthPercent := 100.000000000000000000;
    WebDBEdit7.SetParentComponent(WebPanel4);
    WebDBEdit7.Name := 'WebDBEdit7';
    WebDBEdit7.Left := 135;
    WebDBEdit7.Top := 171;
    WebDBEdit7.Width := 121;
    WebDBEdit7.Height := 22;
    WebDBEdit7.ChildOrder := 6;
    WebDBEdit7.HeightPercent := 100.000000000000000000;
    WebDBEdit7.Text := 'WebDBEdit7';
    WebDBEdit7.WidthPercent := 100.000000000000000000;
    WebDBEdit8.SetParentComponent(WebPanel4);
    WebDBEdit8.Name := 'WebDBEdit8';
    WebDBEdit8.Left := 135;
    WebDBEdit8.Top := 199;
    WebDBEdit8.Width := 121;
    WebDBEdit8.Height := 22;
    WebDBEdit8.ChildOrder := 7;
    WebDBEdit8.HeightPercent := 100.000000000000000000;
    WebDBEdit8.Text := 'WebDBEdit8';
    WebDBEdit8.WidthPercent := 100.000000000000000000;
    WebDBEdit9.SetParentComponent(WebPanel4);
    WebDBEdit9.Name := 'WebDBEdit9';
    WebDBEdit9.Left := 437;
    WebDBEdit9.Top := 143;
    WebDBEdit9.Width := 121;
    WebDBEdit9.Height := 22;
    WebDBEdit9.ChildOrder := 8;
    WebDBEdit9.HeightPercent := 100.000000000000000000;
    WebDBEdit9.Text := 'WebDBEdit9';
    WebDBEdit9.WidthPercent := 100.000000000000000000;
    WebDBEdit10.SetParentComponent(WebPanel4);
    WebDBEdit10.Name := 'WebDBEdit10';
    WebDBEdit10.Left := 437;
    WebDBEdit10.Top := 171;
    WebDBEdit10.Width := 121;
    WebDBEdit10.Height := 22;
    WebDBEdit10.ChildOrder := 9;
    WebDBEdit10.HeightPercent := 100.000000000000000000;
    WebDBEdit10.Text := 'WebDBEdit10';
    WebDBEdit10.WidthPercent := 100.000000000000000000;
    WebDBEdit11.SetParentComponent(WebPanel4);
    WebDBEdit11.Name := 'WebDBEdit11';
    WebDBEdit11.Left := 437;
    WebDBEdit11.Top := 199;
    WebDBEdit11.Width := 121;
    WebDBEdit11.Height := 22;
    WebDBEdit11.ChildOrder := 10;
    WebDBEdit11.HeightPercent := 100.000000000000000000;
    WebDBEdit11.Text := 'WebDBEdit11';
    WebDBEdit11.WidthPercent := 100.000000000000000000;
    WebDBCheckBox1.SetParentComponent(WebPanel4);
    WebDBCheckBox1.Name := 'WebDBCheckBox1';
    WebDBCheckBox1.Left := 32;
    WebDBCheckBox1.Top := 229;
    WebDBCheckBox1.Width := 145;
    WebDBCheckBox1.Height := 22;
    WebDBCheckBox1.Alignment := taLeftJustify;
    WebDBCheckBox1.Caption := 'Invoice On loading Qy:';
    WebDBCheckBox1.ChildOrder := 11;
    WebDBCheckBox1.HeightPercent := 100.000000000000000000;
    WebDBCheckBox1.WidthPercent := 100.000000000000000000;
    WebDBCheckBox2.SetParentComponent(WebPanel4);
    WebDBCheckBox2.Name := 'WebDBCheckBox2';
    WebDBCheckBox2.Left := 312;
    WebDBCheckBox2.Top := 224;
    WebDBCheckBox2.Width := 170;
    WebDBCheckBox2.Height := 22;
    WebDBCheckBox2.Alignment := taLeftJustify;
    WebDBCheckBox2.Caption := 'Invoice On Off-Loading Qy:';
    WebDBCheckBox2.ChildOrder := 12;
    WebDBCheckBox2.HeightPercent := 100.000000000000000000;
    WebDBCheckBox2.WidthPercent := 100.000000000000000000;
    WebDBCheckBox3.SetParentComponent(WebPanel4);
    WebDBCheckBox3.Name := 'WebDBCheckBox3';
    WebDBCheckBox3.Left := 207;
    WebDBCheckBox3.Top := 285;
    WebDBCheckBox3.Width := 26;
    WebDBCheckBox3.Height := 22;
    WebDBCheckBox3.ChildOrder := 13;
    WebDBCheckBox3.HeightPercent := 100.000000000000000000;
    WebDBCheckBox3.WidthPercent := 100.000000000000000000;
    WebDBCheckBox4.SetParentComponent(WebPanel4);
    WebDBCheckBox4.Name := 'WebDBCheckBox4';
    WebDBCheckBox4.Left := 529;
    WebDBCheckBox4.Top := 285;
    WebDBCheckBox4.Width := 33;
    WebDBCheckBox4.Height := 22;
    WebDBCheckBox4.ChildOrder := 14;
    WebDBCheckBox4.HeightPercent := 100.000000000000000000;
    WebDBCheckBox4.WidthPercent := 100.000000000000000000;
    WebDBDateTimePicker1.SetParentComponent(WebPanel4);
    WebDBDateTimePicker1.Name := 'WebDBDateTimePicker1';
    WebDBDateTimePicker1.Left := 103;
    WebDBDateTimePicker1.Top := 285;
    WebDBDateTimePicker1.Width := 97;
    WebDBDateTimePicker1.Height := 22;
    WebDBDateTimePicker1.BorderStyle := bsSingle;
    WebDBDateTimePicker1.ChildOrder := 15;
    WebDBDateTimePicker1.Color := clWhite;
    WebDBDateTimePicker1.Date := 46070.437385000000000000;
    WebDBDateTimePicker1.Role := '';
    WebDBDateTimePicker1.Text := '';
    WebDBDateTimePicker2.SetParentComponent(WebPanel4);
    WebDBDateTimePicker2.Name := 'WebDBDateTimePicker2';
    WebDBDateTimePicker2.Left := 426;
    WebDBDateTimePicker2.Top := 285;
    WebDBDateTimePicker2.Width := 97;
    WebDBDateTimePicker2.Height := 22;
    WebDBDateTimePicker2.BorderStyle := bsSingle;
    WebDBDateTimePicker2.ChildOrder := 16;
    WebDBDateTimePicker2.Color := clWhite;
    WebDBDateTimePicker2.Date := 46070.437393900470000000;
    WebDBDateTimePicker2.Role := '';
    WebDBDateTimePicker2.Text := '';
    WebDateTimePicker1.SetParentComponent(WebPanel4);
    WebDateTimePicker1.Name := 'WebDateTimePicker1';
    WebDateTimePicker1.Left := 206;
    WebDateTimePicker1.Top := 312;
    WebDateTimePicker1.Width := 97;
    WebDateTimePicker1.Height := 22;
    WebDateTimePicker1.BorderStyle := bsSingle;
    WebDateTimePicker1.ChildOrder := 18;
    WebDateTimePicker1.Color := clWhite;
    WebDateTimePicker1.Date := 46070.445975613420000000;
    WebDateTimePicker1.Kind := dtkTime;
    WebDateTimePicker1.Role := '';
    WebDateTimePicker1.Text := '';
    WebDateTimePicker2.SetParentComponent(WebPanel4);
    WebDateTimePicker2.Name := 'WebDateTimePicker2';
    WebDateTimePicker2.Left := 103;
    WebDateTimePicker2.Top := 312;
    WebDateTimePicker2.Width := 97;
    WebDateTimePicker2.Height := 22;
    WebDateTimePicker2.BorderStyle := bsSingle;
    WebDateTimePicker2.ChildOrder := 18;
    WebDateTimePicker2.Color := clWhite;
    WebDateTimePicker2.Date := 46070.448470509260000000;
    WebDateTimePicker2.Role := '';
    WebDateTimePicker2.Text := '';
    WebDateTimePicker3.SetParentComponent(WebPanel4);
    WebDateTimePicker3.Name := 'WebDateTimePicker3';
    WebDateTimePicker3.Left := 400;
    WebDateTimePicker3.Top := 312;
    WebDateTimePicker3.Width := 97;
    WebDateTimePicker3.Height := 22;
    WebDateTimePicker3.BorderStyle := bsSingle;
    WebDateTimePicker3.ChildOrder := 18;
    WebDateTimePicker3.Color := clWhite;
    WebDateTimePicker3.Date := 46070.448470509260000000;
    WebDateTimePicker3.Role := '';
    WebDateTimePicker3.Text := '';
    WebDateTimePicker4.SetParentComponent(WebPanel4);
    WebDateTimePicker4.Name := 'WebDateTimePicker4';
    WebDateTimePicker4.Left := 503;
    WebDateTimePicker4.Top := 312;
    WebDateTimePicker4.Width := 97;
    WebDateTimePicker4.Height := 22;
    WebDateTimePicker4.BorderStyle := bsSingle;
    WebDateTimePicker4.ChildOrder := 18;
    WebDateTimePicker4.Color := clWhite;
    WebDateTimePicker4.Date := 46070.445975613420000000;
    WebDateTimePicker4.Kind := dtkTime;
    WebDateTimePicker4.Role := '';
    WebDateTimePicker4.Text := '';
    WebDateTimePicker5.SetParentComponent(WebPanel4);
    WebDateTimePicker5.Name := 'WebDateTimePicker5';
    WebDateTimePicker5.Left := 103;
    WebDateTimePicker5.Top := 340;
    WebDateTimePicker5.Width := 97;
    WebDateTimePicker5.Height := 22;
    WebDateTimePicker5.BorderStyle := bsSingle;
    WebDateTimePicker5.ChildOrder := 18;
    WebDateTimePicker5.Color := clWhite;
    WebDateTimePicker5.Date := 46070.448470509260000000;
    WebDateTimePicker5.Role := '';
    WebDateTimePicker5.Text := '';
    WebDateTimePicker6.SetParentComponent(WebPanel4);
    WebDateTimePicker6.Name := 'WebDateTimePicker6';
    WebDateTimePicker6.Left := 206;
    WebDateTimePicker6.Top := 340;
    WebDateTimePicker6.Width := 97;
    WebDateTimePicker6.Height := 22;
    WebDateTimePicker6.BorderStyle := bsSingle;
    WebDateTimePicker6.ChildOrder := 18;
    WebDateTimePicker6.Color := clWhite;
    WebDateTimePicker6.Date := 46070.445975613420000000;
    WebDateTimePicker6.Kind := dtkTime;
    WebDateTimePicker6.Role := '';
    WebDateTimePicker6.Text := '';
    WebDateTimePicker7.SetParentComponent(WebPanel4);
    WebDateTimePicker7.Name := 'WebDateTimePicker7';
    WebDateTimePicker7.Left := 400;
    WebDateTimePicker7.Top := 340;
    WebDateTimePicker7.Width := 97;
    WebDateTimePicker7.Height := 22;
    WebDateTimePicker7.BorderStyle := bsSingle;
    WebDateTimePicker7.ChildOrder := 18;
    WebDateTimePicker7.Color := clWhite;
    WebDateTimePicker7.Date := 46070.448470509260000000;
    WebDateTimePicker7.Role := '';
    WebDateTimePicker7.Text := '';
    WebDateTimePicker8.SetParentComponent(WebPanel4);
    WebDateTimePicker8.Name := 'WebDateTimePicker8';
    WebDateTimePicker8.Left := 503;
    WebDateTimePicker8.Top := 340;
    WebDateTimePicker8.Width := 97;
    WebDateTimePicker8.Height := 22;
    WebDateTimePicker8.BorderStyle := bsSingle;
    WebDateTimePicker8.ChildOrder := 18;
    WebDateTimePicker8.Color := clWhite;
    WebDateTimePicker8.Date := 46070.445975613420000000;
    WebDateTimePicker8.Kind := dtkTime;
    WebDateTimePicker8.Role := '';
    WebDateTimePicker8.Text := '';
    WebDBCheckBox5.SetParentComponent(WebPanel4);
    WebDBCheckBox5.Name := 'WebDBCheckBox5';
    WebDBCheckBox5.Left := 32;
    WebDBCheckBox5.Top := 408;
    WebDBCheckBox5.Width := 113;
    WebDBCheckBox5.Height := 22;
    WebDBCheckBox5.Alignment := taLeftJustify;
    WebDBCheckBox5.Caption := 'Invoice Non VAT:';
    WebDBCheckBox5.ChildOrder := 25;
    WebDBCheckBox5.HeightPercent := 100.000000000000000000;
    WebDBCheckBox5.WidthPercent := 100.000000000000000000;
    WebDBEdit12.SetParentComponent(WebPanel4);
    WebDBEdit12.Name := 'WebDBEdit12';
    WebDBEdit12.Left := 305;
    WebDBEdit12.Top := 422;
    WebDBEdit12.Width := 177;
    WebDBEdit12.Height := 22;
    WebDBEdit12.ChildOrder := 26;
    WebDBEdit12.HeightPercent := 100.000000000000000000;
    WebDBEdit12.Text := 'WebDBEdit12';
    WebDBEdit12.WidthPercent := 100.000000000000000000;
    WebDateTimePicker9.SetParentComponent(WebPanel4);
    WebDateTimePicker9.Name := 'WebDateTimePicker9';
    WebDateTimePicker9.Left := 386;
    WebDateTimePicker9.Top := 452;
    WebDateTimePicker9.Width := 121;
    WebDateTimePicker9.Height := 22;
    WebDateTimePicker9.BorderStyle := bsSingle;
    WebDateTimePicker9.ChildOrder := 27;
    WebDateTimePicker9.Color := clWhite;
    WebDateTimePicker9.Date := 46070.452885856480000000;
    WebDateTimePicker9.Role := '';
    WebDateTimePicker9.Text := '';
    WebEdit1.SetParentComponent(WebPanel4);
    WebEdit1.Name := 'WebEdit1';
    WebEdit1.Left := 386;
    WebEdit1.Top := 483;
    WebEdit1.Width := 121;
    WebEdit1.Height := 22;
    WebEdit1.ChildOrder := 28;
    WebEdit1.HeightPercent := 100.000000000000000000;
    WebEdit1.Text := 'WebEdit1';
    WebEdit1.WidthPercent := 100.000000000000000000;
    WebDBCheckBox6.SetParentComponent(WebPanel4);
    WebDBCheckBox6.Name := 'WebDBCheckBox6';
    WebDBCheckBox6.Left := 306;
    WebDBCheckBox6.Top := 511;
    WebDBCheckBox6.Width := 103;
    WebDBCheckBox6.Height := 22;
    WebDBCheckBox6.Alignment := taLeftJustify;
    WebDBCheckBox6.Caption := 'Sub Invoiced:';
    WebDBCheckBox6.ChildOrder := 29;
    WebDBCheckBox6.HeightPercent := 100.000000000000000000;
    WebDBCheckBox6.WidthPercent := 100.000000000000000000;
    WebDBEdit13.SetParentComponent(WebPanel4);
    WebDBEdit13.Name := 'WebDBEdit13';
    WebDBEdit13.Left := 112;
    WebDBEdit13.Top := 452;
    WebDBEdit13.Width := 121;
    WebDBEdit13.Height := 22;
    WebDBEdit13.ChildOrder := 30;
    WebDBEdit13.HeightPercent := 100.000000000000000000;
    WebDBEdit13.Text := 'WebDBEdit13';
    WebDBEdit13.WidthPercent := 100.000000000000000000;
    WebDBEdit14.SetParentComponent(WebPanel4);
    WebDBEdit14.Name := 'WebDBEdit14';
    WebDBEdit14.Left := 112;
    WebDBEdit14.Top := 480;
    WebDBEdit14.Width := 121;
    WebDBEdit14.Height := 22;
    WebDBEdit14.ChildOrder := 31;
    WebDBEdit14.HeightPercent := 100.000000000000000000;
    WebDBEdit14.Text := 'WebDBEdit14';
    WebDBEdit14.WidthPercent := 100.000000000000000000;
    WebDBEdit15.SetParentComponent(WebPanel4);
    WebDBEdit15.Name := 'WebDBEdit15';
    WebDBEdit15.Left := 112;
    WebDBEdit15.Top := 508;
    WebDBEdit15.Width := 121;
    WebDBEdit15.Height := 22;
    WebDBEdit15.ChildOrder := 32;
    WebDBEdit15.HeightPercent := 100.000000000000000000;
    WebDBEdit15.Text := 'WebDBEdit15';
    WebDBEdit15.WidthPercent := 100.000000000000000000;
    WebDBEdit16.SetParentComponent(WebPanel4);
    WebDBEdit16.Name := 'WebDBEdit16';
    WebDBEdit16.Left := 112;
    WebDBEdit16.Top := 536;
    WebDBEdit16.Width := 121;
    WebDBEdit16.Height := 22;
    WebDBEdit16.ChildOrder := 33;
    WebDBEdit16.HeightPercent := 100.000000000000000000;
    WebDBEdit16.Text := 'WebDBEdit16';
    WebDBEdit16.WidthPercent := 100.000000000000000000;
    WebDBEdit17.SetParentComponent(WebPanel4);
    WebDBEdit17.Name := 'WebDBEdit17';
    WebDBEdit17.Left := 112;
    WebDBEdit17.Top := 564;
    WebDBEdit17.Width := 121;
    WebDBEdit17.Height := 22;
    WebDBEdit17.ChildOrder := 34;
    WebDBEdit17.HeightPercent := 100.000000000000000000;
    WebDBEdit17.Text := 'WebDBEdit17';
    WebDBEdit17.WidthPercent := 100.000000000000000000;
    WebPanel3.SetParentComponent(WebPanel4);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 0;
    WebPanel3.Top := 625;
    WebPanel3.Width := 633;
    WebPanel3.Height := 60;
    WebPanel3.Align := alBottom;
    WebPanel3.ChildOrder := 60;
    WebPanel3.Color := clSilver;
    WebPanel3.TabOrder := 35;
    WebButton1.SetParentComponent(WebPanel3);
    WebButton1.Name := 'WebButton1';
    WebButton1.Left := 24;
    WebButton1.Top := 16;
    WebButton1.Width := 96;
    WebButton1.Height := 25;
    WebButton1.Caption := 'Save';
    WebButton1.Color := clGreenyellow;
    WebButton1.HeightPercent := 100.000000000000000000;
    WebButton1.WidthPercent := 100.000000000000000000;
    WebButton2.SetParentComponent(WebPanel3);
    WebButton2.Name := 'WebButton2';
    WebButton2.Left := 137;
    WebButton2.Top := 16;
    WebButton2.Width := 96;
    WebButton2.Height := 25;
    WebButton2.Caption := 'Close';
    WebButton2.Color := clRed;
    WebButton2.ChildOrder := 1;
    WebButton2.HeightPercent := 100.000000000000000000;
    WebButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton2, Self, 'OnClick', 'WebButton2Click');
    Invoice.SetParentComponent(WebPanel3);
    Invoice.Name := 'Invoice';
    Invoice.Left := 267;
    Invoice.Top := 10;
    Invoice.Width := 121;
    Invoice.Height := 40;
    Invoice.ChildOrder := 61;
    Documentation.SetParentComponent(WebPanel3);
    Documentation.Name := 'Documentation';
    Documentation.Left := 402;
    Documentation.Top := 10;
    Documentation.Width := 121;
    Documentation.Height := 40;
    Documentation.ChildOrder := 62;
  finally
    WebPanel1.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    WebPanel4.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    WebLabel7.AfterLoadDFMValues;
    WebLabel8.AfterLoadDFMValues;
    WebLabel9.AfterLoadDFMValues;
    WebLabel10.AfterLoadDFMValues;
    WebLabel11.AfterLoadDFMValues;
    WebLabel12.AfterLoadDFMValues;
    WebLabel13.AfterLoadDFMValues;
    WebLabel14.AfterLoadDFMValues;
    WebLabel15.AfterLoadDFMValues;
    WebLabel16.AfterLoadDFMValues;
    WebLabel17.AfterLoadDFMValues;
    WebLabel18.AfterLoadDFMValues;
    WebLabel19.AfterLoadDFMValues;
    WebLabel20.AfterLoadDFMValues;
    WebLabel21.AfterLoadDFMValues;
    WebLabel22.AfterLoadDFMValues;
    WebLabel23.AfterLoadDFMValues;
    WebLabel24.AfterLoadDFMValues;
    WebLabel25.AfterLoadDFMValues;
    WebDBEdit1.AfterLoadDFMValues;
    WebDBEdit2.AfterLoadDFMValues;
    WebDBEdit3.AfterLoadDFMValues;
    WebDBEdit4.AfterLoadDFMValues;
    WebDBEdit5.AfterLoadDFMValues;
    WebDBEdit6.AfterLoadDFMValues;
    WebDBEdit7.AfterLoadDFMValues;
    WebDBEdit8.AfterLoadDFMValues;
    WebDBEdit9.AfterLoadDFMValues;
    WebDBEdit10.AfterLoadDFMValues;
    WebDBEdit11.AfterLoadDFMValues;
    WebDBCheckBox1.AfterLoadDFMValues;
    WebDBCheckBox2.AfterLoadDFMValues;
    WebDBCheckBox3.AfterLoadDFMValues;
    WebDBCheckBox4.AfterLoadDFMValues;
    WebDBDateTimePicker1.AfterLoadDFMValues;
    WebDBDateTimePicker2.AfterLoadDFMValues;
    WebDateTimePicker1.AfterLoadDFMValues;
    WebDateTimePicker2.AfterLoadDFMValues;
    WebDateTimePicker3.AfterLoadDFMValues;
    WebDateTimePicker4.AfterLoadDFMValues;
    WebDateTimePicker5.AfterLoadDFMValues;
    WebDateTimePicker6.AfterLoadDFMValues;
    WebDateTimePicker7.AfterLoadDFMValues;
    WebDateTimePicker8.AfterLoadDFMValues;
    WebDBCheckBox5.AfterLoadDFMValues;
    WebDBEdit12.AfterLoadDFMValues;
    WebDateTimePicker9.AfterLoadDFMValues;
    WebEdit1.AfterLoadDFMValues;
    WebDBCheckBox6.AfterLoadDFMValues;
    WebDBEdit13.AfterLoadDFMValues;
    WebDBEdit14.AfterLoadDFMValues;
    WebDBEdit15.AfterLoadDFMValues;
    WebDBEdit16.AfterLoadDFMValues;
    WebDBEdit17.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    WebButton1.AfterLoadDFMValues;
    WebButton2.AfterLoadDFMValues;
    Invoice.AfterLoadDFMValues;
    Documentation.AfterLoadDFMValues;
  end;
end;

end.
